import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { useInitialization } from '../../contexts/Initialization'
import { SETUP_MFA_ENFORCED } from '../../constants/links'
import { navigateTo } from '../../utils/redirect/navigator'
import { computeShouldSetupMFA } from '../../hooks/useAppInit'

const removeTrailingSlash = (str) =>
  str.endsWith('/') ? str.slice(0, -1) : str

export function MfaGuard() {
  const location = useLocation()
  const { user } = useInitialization() || {}
  const shouldSetupMFA = computeShouldSetupMFA(user)

  useEffect(() => {
    const route = removeTrailingSlash(location.pathname)
    const mfaEnforcedRoute = removeTrailingSlash(SETUP_MFA_ENFORCED)
    const isMfaSetupRoute =
      route === mfaEnforcedRoute || route.startsWith(`${mfaEnforcedRoute}/`)

    if (shouldSetupMFA && !isMfaSetupRoute) {
      // SETUP_MFA_ENFORCED ('/users/settings/mfa') moved to the login app
      // (AUTHN-3512) — a client-side navigate can no longer reach it since
      // it's a different bundle, so this is a full page redirect.
      navigateTo(SETUP_MFA_ENFORCED)
    }
  }, [location.pathname, shouldSetupMFA])

  return <Outlet />
}
